import React, { useState } from "react";
import { Container, Row, Col, Dropdown, Button } from "react-bootstrap";
import DeleteTicketsModal from "../../../components/modals/hrm/tickets/DeleteTicketsModal";
import EditTicketModal from "../../../components/modals/hrm/tickets/EditTicketModal";
import TicketCard from "../../../components/crm/tickets/TicketCard";
import TicketsHeader from "../../../components/crm/tickets/TicketsHeader";
import TicketStats from "../../../components/crm/tickets/TicketStats";
// import TicketCard from "../components/TicketCard";
// import EditTicketModal from "../components/EditTicketModal";
// import DeleteModal from "../components/DeleteModal";

export default function TicketGridPage() {
const [tickets, setTickets] = useState([
  {
    id: 1,
    title: "Laptop Issue",
    code: "Tic - 001",
    category: "Hardware Issues",
    status: "Open",
    priority: "Low",
    user: "Edgar Hansel",
    img: "/assets/img/users/user-49.jpg",
  },
  {
    id: 2,
    title: "Payment Issue",
    code: "Tic - 002",
    category: "Software Issues",
    status: "Open",
    priority: "High",
    user: "Edgar Hansel",
    img: "/assets/img/users/user-09.jpg",
  },
  {
    id: 3,
    title: "Bug Report",
    code: "Tic - 003",
    category: "IT Support",
    status: "Open",
    priority: "High",
    user: "Edgar Hansel",
    img: "/assets/img/users/user-01-1.jpg",
  },
  {
    id: 4,
    title: "Access Denied",
    code: "Tic - 004",
    category: "IT Support",
    status: "Open",
    priority: "High",
    user: "Edgar Hansel",
    img: "/assets/img/users/user-33-1.jpg",
  },
  {
    id: 5,
    title: "Display Glitch",
    code: "Tic - 005",
    category: "Hardware Issues",
    status: "Open",
    priority: "High",
    user: "Edgar Hansel",
    img: "/assets/img/users/user-34.jpg",
  },
  {
    id: 6,
    title: "Security Alert",
    code: "Tic - 006",
    category: "IT Support",
    status: "Open",
    priority: "High",
    user: "Edgar Hansel",
    img: "/assets/img/users/user-02.jpg",
  },
  {
    id: 7,
    title: "Connectivity Issue",
    code: "Tic - 007",
    category: "Connectivity",
    status: "Open",
    priority: "High",
    user: "Edgar Hansel",
    img: "/assets/img/users/user-35-1.jpg",
  },
  {
    id: 8,
    title: "Update Error",
    code: "Tic - 008",
    category: "IT Support",
    status: "Open",
    priority: "High",
    user: "Edgar Hansel",
    img: "/assets/img/users/user-36.jpg",
  },
  {
    id: 9,
    title: "Login Failure",
    code: "Tic - 009",
    category: "IT Support",
    status: "Open",
    priority: "High",
    user: "Edgar Hansel",
    img: "/assets/img/users/user-37.jpg",
  },
  {
    id: 10,
    title: "Server Timeout",
    code: "Tic - 010",
    category: "Connectivity",
    status: "Open",
    priority: "High",
    user: "Edgar Hansel",
    img: "/assets/img/users/user-38.jpg",
  },
  {
    id: 11,
    title: "Email Client Setup",
    code: "Tic - 011",
    category: "IT Support",
    status: "Open",
    priority: "Medium",
    user: "Edgar Hansel",
    img: "/assets/img/users/user-30-1.jpg",
  },
  {
    id: 12,
    title: "Application Crashing",
    code: "Tic - 012",
    category: "Software Issues",
    status: "Open",
    priority: "High",
    user: "Edgar Hansel",
    img: "/assets/img/users/user-56.jpg",
  },
]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  return (

   <div  style={{ padding: "15px", background: "#f8f9fa",  }} >
     <TicketsHeader  tittle="Ticket Grid" />
     <TicketStats/>
        {/* HEADER */}
      <div className="card-tickets mb-3 p-3">
        <div className="d-flex justify-content-between flex-wrap">
          <h5>Ticket Grid</h5>

          <div className="d-flex gap-2 flex-wrap">
            <Dropdown>
              <Dropdown.Toggle size="sm"   className="border brder-2" variant="light">
                Priority
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>High</Dropdown.Item>
                <Dropdown.Item>Low</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown>
              <Dropdown.Toggle  className="border brder-2" size="sm" variant="light">
                Select Status
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Open</Dropdown.Item>
                <Dropdown.Item>Closed</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown>
              <Dropdown.Toggle  className="border brder-2" size="sm" variant="light">
                Sort By : Last 7 Days
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Ascending</Dropdown.Item>
                <Dropdown.Item>Descending</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>

      {/* GRID */}
      <Row>
        {tickets.map((ticket) => (
          <Col xl={3} lg={4} md={6} sm={12} key={ticket.id}>
            <TicketCard
              ticket={ticket}
              onEdit={() => {
                setSelectedTicket(ticket);
                setShowEdit(true);
              }}
              onDelete={() => {
                setSelectedTicket(ticket);
                setShowDelete(true);
              }}
            />
          </Col>
        ))}
      </Row>

      {/* MODALS */}
      <EditTicketModal
        show={showEdit}
        handleClose={() => setShowEdit(false)}
        ticket={selectedTicket}
      />

      <DeleteTicketsModal
        show={showDelete}
        handleClose={() => setShowDelete(false)}
        onConfirm={() => {
          setTickets(tickets.filter(t => t.id !== selectedTicket.id));
          setShowDelete(false);
        }}
      />
      <style>
          {
               `
               .card-tickets{
               border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
box-shadow:0 2px 5px rgba(0,0,0,0.05);
               
               }`
          }
      </style>
   </div>

  );
}